import { seoMeta } from "@/lib/ui/seo";
import { getHeroListings, type HeroListing } from "./hero-listings";

export const aboutRoute = {
    loader: async () => {
        try {
            return await getHeroListings();
        } catch (error) {
            console.error("[hero] Failed to load hero listings:", error);
            return [] as HeroListing[];
        }
    },
    head: () => ({
        ...seoMeta({
            title: "Wags — Find a dog that fits your life",
            description:
                "Every breeder, shelter, and rescue in one place. Find the dog that fits your life. Free to use.",
            url: "/about",
        }),
    }),
};
